'use client';

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  cn,
} from '@baseball-near-you/ui';
import type { FAQs as IFAQs } from '@bb/sanity.types';
import { useState } from 'react';
import { SanityWrapper, Title } from '../SanityWrapper';

export function FAQs({ block }: { block: IFAQs }) {
  const [active, setActive] = useState<string[] | null>(null);
  return (
    <SanityWrapper>
      <div className="flex w-full flex-col items-center">
        {!!block.title && <Title title={block.title} />}
        {!!block.subtitle && (
          <h3 className="font-medium text-base">{block.subtitle}</h3>
        )}
      </div>
      <Accordion type="multiple" className="faq" onValueChange={setActive}>
        {block.faqs?.map((faq, index) => {
          return (
            <AccordionItem
              className="question"
              value={faq.question}
              key={faq.question}
            >
              <AccordionTrigger
                className={cn(
                  'text-left',
                  active?.includes(faq.question) && 'text-red'
                )}
              >
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-base">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          );
        })}
      </Accordion>
    </SanityWrapper>
  );
}
